import React from 'react';
import Icon from '../../../components/appIcon';

const MetricCard = ({ title, value, icon, iconColor = "text-blue-600" }) => {
  return (
    <div className="group  relative bg-white rounded-xl p-4 shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden transform hover:-translate-y-1">
      {/* Animated gradient background on hover */}
      <div className="absolute inset-0 rounded-lg bg-gradient-to-br from-blue-50 via-purple-50 to-pink-50 opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>

      {/* Animated circle decoration */}
      <div className="absolute -top-8 -right-8 w-20 h-20 bg-gradient-to-br from-blue-100 to-purple-100 rounded-full opacity-20 group-hover:scale-150 transition-transform duration-700"></div>

      <div className="relative z-10">
        {/* Header with icon */}
        <div className="flex items-center justify-between mb-3">
          <div className={`p-2 rounded-xl bg-gradient-to-br from-blue-50 to-blue-100 ${iconColor} group-hover:scale-110 group-hover:rotate-12 transition-all duration-300 shadow-sm`}>
            <Icon name={icon} size={20} />
          </div>
          <div className="flex space-x-1">
            <div className="w-1.5 h-1.5 bg-blue-400 rounded-full animate-pulse"></div>
            <div className="w-1.5 h-1.5 bg-purple-400 rounded-full animate-pulse delay-75"></div>
            <div className="w-1.5 h-1.5 bg-pink-400 rounded-full animate-pulse delay-150"></div>
          </div>
        </div>

        {/* Value and title */}
        <div className="space-y-1">
          <h3 className="text-2xl font-bold text-gray-800 group-hover:text-blue-600 transition-colors duration-300">
            {value}
          </h3>
          <p className="text-xs text-gray-500 font-medium uppercase tracking-wider">
            {title}
          </p>
        </div>

        {/* Progress bar */}
        <div className="mt-3 h-1 bg-gray-100 rounded-full overflow-hidden">
          <div className="h-full bg-gradient-to-r from-blue-400 via-purple-400 to-pink-400 rounded-full group-hover:animate-progress w-0 group-hover:w-3/4 transition-all duration-1000"></div>
        </div>
      </div>

      <style jsx>{`
        @keyframes progress {
          0% { transform: translateX(-100%); }
          100% { transform: translateX(0); }
        }
        .animate-progress {
          animation: progress 1s ease-out;
        }
        .delay-75 {
          animation-delay: 75ms;
        }
        .delay-150 {
          animation-delay: 150ms;
        }
      `}</style>
    </div>
  );
};

export default MetricCard;